// spinner.component.ts
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingService } from '../../services/loading.service';

@Component({
    selector: 'app-spinner',
    template: `
    @if (isLoading$ | async) {
      <div class="overlay">
        <div class="spinner"></div>
        @if (message$ | async; as message) {
          <div class="message">{{ message }}</div>
        }
      </div>
    }
    `,
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent {
  isLoading$: Observable<boolean>;
  message$: Observable<string>;

  constructor(private loadingService: LoadingService) {
    this.isLoading$ = this.loadingService.isLoading$;
    this.message$ = this.loadingService.message$;
  }
}
